"use strict";
var $ = require("../internals/export");
var trimEnd = require("../internals/string-trim-end");
$({ target: "String", proto: true, name: "trimEnd", forced: "".trimRight !== trimEnd }, {
  trimRight: trimEnd
});
